/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ErrorDisplay } from "cms/shared/error_display";
import { usePageNav } from "cms/shared/page-nav";
import { Menu } from "cms/shared/page-nav/menu";
import { ReactComponent as ServicesIcon } from "cms/assets/icons/square-grid.svg";

const ServicesSideNav = (props) => {
    const { webpage } = props;
    const { guid } = webpage || {};

    const {
        error,
        sectionTree,
        selectedSections,
        openMenus,
        setOpenMenus,
        openAllMenus
    } = usePageNav(guid);
    const { children: treeChildren } = sectionTree || {};

    useEffect(() => {
        // Open all menus by default
        openAllMenus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return (
        <div className='services-side-nav side-nav'>
            <div className='services-side-nav-links'>
                <Link to='/services' className='your-services-nav-link'>
                    <h3>Your services</h3>
                    <ServicesIcon alt='services-icon' />
                </Link>
                <Menu
                    tree={treeChildren}
                    currentPageGuid={guid}
                    openMenus={openMenus}
                    setOpenMenus={setOpenMenus}
                    selectedSections={selectedSections}
                />
            </div>
            {/* <div className='built-with-simplicity'>
                <span>Built with SimpliCity</span><sup>&trade;</sup>
            </div> */}

            <ErrorDisplay error={error} />
        </div>
    );
};

export { ServicesSideNav };
